__turbopack_context__.v({
  "agentDetails": "style-module-scss-module__Uw_7Pa__agentDetails",
  "agentInfo": "style-module-scss-module__Uw_7Pa__agentInfo",
  "agentName": "style-module-scss-module__Uw_7Pa__agentName",
  "agentTitle": "style-module-scss-module__Uw_7Pa__agentTitle",
  "avatar": "style-module-scss-module__Uw_7Pa__avatar",
  "avatarContainer": "style-module-scss-module__Uw_7Pa__avatarContainer",
  "avatarPlaceholder": "style-module-scss-module__Uw_7Pa__avatarPlaceholder",
  "card": "style-module-scss-module__Uw_7Pa__card",
  "component": "style-module-scss-module__Uw_7Pa__component",
  "contactActions": "style-module-scss-module__Uw_7Pa__contactActions",
  "contactButton": "style-module-scss-module__Uw_7Pa__contactButton",
  "customMessage": "style-module-scss-module__Uw_7Pa__customMessage",
  "icon": "style-module-scss-module__Uw_7Pa__icon",
  "messageText": "style-module-scss-module__Uw_7Pa__messageText",
});
